import { createContext } from 'preact';
export interface TrainContextType {
  onSelect: (event: Event, stepId: string) => void;
  selectedStep: string;
  numberOfSteps: number;
  selectedStepIndex: number;
  index: number;
  isCurrent: boolean;
}

export const Context = createContext<any>(null);
